var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "700pt",
        height: "700pt",
        version: "1.1",
        viewBox: "0 0 700 700",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("defs", [
        _c("symbol", { attrs: { id: "i", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m29.312-1.75c-1.5117 0.78125-3.0898 1.3711-4.7344 1.7656-1.6367 0.40625-3.3398 0.60938-5.1094 0.60938-5.3125 0-9.5273-1.4844-12.641-4.4531-3.1055-2.9688-4.6562-7-4.6562-12.094s1.5508-9.125 4.6562-12.094c3.1133-2.9688 7.3281-4.4531 12.641-4.4531 1.7695 0 3.4727 0.19922 5.1094 0.59375 1.6445 0.39844 3.2227 0.99219 4.7344 1.7812v6.5938c-1.5312-1.0391-3.0391-1.8008-4.5156-2.2812-1.4805-0.48828-3.0391-0.73438-4.6719-0.73438-2.9375 0-5.2461 0.94531-6.9219 2.8281-1.6797 1.875-2.5156 4.4648-2.5156 7.7656 0 3.293 0.83594 5.8828 2.5156 7.7656 1.6758 1.875 3.9844 2.8125 6.9219 2.8125 1.6328 0 3.1914-0.23828 4.6719-0.71875 1.4766-0.48828 2.9844-1.2539 4.5156-2.2969z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "d", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m21.453-17.406c-0.67969-0.3125-1.3516-0.53906-2.0156-0.6875-0.65625-0.15625-1.3203-0.23438-1.9844-0.23438-1.9688 0-3.4844 0.63281-4.5469 1.8906-1.0547 1.2617-1.5781 3.0703-1.5781 5.4219v11.016h-7.6562v-23.922h7.6562v3.9219c0.97656-1.5625 2.1016-2.7031 3.375-3.4219 1.2812-0.71875 2.8125-1.0781 4.5938-1.0781 0.25 0 0.52344 0.011719 0.82812 0.03125 0.30078 0.023438 0.73438 0.070312 1.2969 0.14062z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "c", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m27.562-12.031v2.1875h-17.891c0.1875 1.793 0.83203 3.1367 1.9375 4.0312 1.1133 0.89844 2.6719 1.3438 4.6719 1.3438 1.6016 0 3.25-0.23438 4.9375-0.70312 1.6875-0.47656 3.4219-1.2031 5.2031-2.1719v5.8906c-1.8047 0.6875-3.6094 1.2031-5.4219 1.5469-1.8125 0.35156-3.6211 0.53125-5.4219 0.53125-4.3359 0-7.7031-1.0977-10.109-3.2969-2.3984-2.207-3.5938-5.2969-3.5938-9.2656 0-3.9062 1.1758-6.9727 3.5312-9.2031 2.3633-2.2383 5.6094-3.3594 9.7344-3.3594 3.7578 0 6.7695 1.1367 9.0312 3.4062 2.2578 2.2617 3.3906 5.2812 3.3906 9.0625zm-7.8594-2.5312c0-1.457-0.42969-2.6289-1.2812-3.5156-0.84375-0.89453-1.9492-1.3438-3.3125-1.3438-1.4922 0-2.6992 0.41797-3.625 1.25-0.91797 0.83594-1.4922 2.0391-1.7188 3.6094z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "a", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m14.391-10.766c-1.5938 0-2.793 0.27344-3.5938 0.8125-0.80469 0.54297-1.2031 1.3398-1.2031 2.3906 0 0.96875 0.32031 1.7305 0.96875 2.2812 0.64453 0.54297 1.5469 0.8125 2.7031 0.8125 1.4375 0 2.6445-0.51562 3.625-1.5469 0.98828-1.0312 1.4844-2.3203 1.4844-3.875v-0.875zm11.688-2.8906v13.656h-7.7031v-3.5469c-1.0312 1.4492-2.1875 2.5078-3.4688 3.1719s-2.8398 1-4.6719 1c-2.4805 0-4.4961-0.72266-6.0469-2.1719-1.543-1.4453-2.3125-3.3203-2.3125-5.625 0-2.8125 0.96094-4.8672 2.8906-6.1719 1.9375-1.3125 4.9688-1.9688 9.0938-1.9688h4.5156v-0.60938c0-1.207-0.48047-2.0938-1.4375-2.6562-0.94922-0.5625-2.4375-0.84375-4.4688-0.84375-1.6367 0-3.1562 0.16797-4.5625 0.5-1.4062 0.32422-2.7188 0.8125-3.9375 1.4688v-5.8281c1.6445-0.40625 3.2891-0.70703 4.9375-0.90625 1.6562-0.20703 3.3047-0.3125 4.9531-0.3125 4.3203 0 7.4375 0.85547 9.3438 2.5625 1.9141 1.6992 2.875 4.4609 2.875 8.2812z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "h", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m12.031-30.719v6.7969h7.875v5.4688h-7.875v10.141c0 1.1172 0.21875 1.8711 0.65625 2.2656 0.4375 0.38672 1.3125 0.57812 2.625 0.57812h3.9375v5.4688h-6.5625c-3.0234 0-5.1641-0.62891-6.4219-1.8906-1.2617-1.2578-1.8906-3.3984-1.8906-6.4219v-10.141h-3.7969v-5.4688h3.7969v-6.7969z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "b", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m19.953-20.422v-12.812h7.6875v33.234h-7.6875v-3.4531c-1.0547 1.4062-2.2148 2.4375-3.4844 3.0938-1.2734 0.65625-2.7422 0.98438-4.4062 0.98438-2.9492 0-5.3711-1.1719-7.2656-3.5156-1.8867-2.3438-2.8281-5.3594-2.8281-9.0469s0.94141-6.7031 2.8281-9.0469c1.8945-2.3438 4.3164-3.5156 7.2656-3.5156 1.6562 0 3.1172 0.33594 4.3906 1 1.2812 0.65625 2.4453 1.6836 3.5 3.0781zm-5.0469 15.484c1.6445 0 2.8945-0.59766 3.75-1.7969 0.86328-1.1953 1.2969-2.9297 1.2969-5.2031 0-2.2812-0.43359-4.0195-1.2969-5.2188-0.85547-1.1953-2.1055-1.7969-3.75-1.7969-1.625 0-2.8711 0.60156-3.7344 1.7969-0.85547 1.1992-1.2812 2.9375-1.2812 5.2188 0 2.2734 0.42578 4.0078 1.2812 5.2031 0.86328 1.1992 2.1094 1.7969 3.7344 1.7969z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "g", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m16.406-4.9375c1.6328 0 2.8828-0.59766 3.75-1.7969 0.86328-1.1953 1.2969-2.9297 1.2969-5.2031 0-2.2812-0.43359-4.0195-1.2969-5.2188-0.86719-1.1953-2.1172-1.7969-3.75-1.7969-1.6367 0-2.8906 0.60547-3.7656 1.8125-0.875 1.1992-1.3125 2.9336-1.3125 5.2031 0 2.2617 0.4375 3.9961 1.3125 5.2031 0.875 1.1992 2.1289 1.7969 3.7656 1.7969zm-5.0781-15.484c1.0508-1.3945 2.2188-2.4219 3.5-3.0781 1.2812-0.66406 2.7539-1 4.4219-1 2.9453 0 5.3672 1.1719 7.2656 3.5156 1.8945 2.3438 2.8438 5.3594 2.8438 9.0469s-0.94922 6.7031-2.8438 9.0469c-1.8984 2.3438-4.3203 3.5156-7.2656 3.5156-1.668 0-3.1406-0.33594-4.4219-1s-2.4492-1.6914-3.5-3.0781v3.4531h-7.6562v-33.234h7.6562z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "f", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m0.53125-23.922h7.6562l6.4219 16.234 5.4688-16.234h7.6562l-10.062 26.188c-1.0117 2.6641-2.1953 4.5234-3.5469 5.5781-1.3438 1.0625-3.1211 1.5938-5.3281 1.5938h-4.4219v-5.0156h2.3906c1.3008 0 2.2422-0.21094 2.8281-0.625 0.59375-0.40625 1.0547-1.1484 1.3906-2.2188l0.20312-0.65625z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "e", overflow: "visible" } }, [
          _c("path", {
            attrs: {
              d: "m12.234-25.672v19.453h2.9531c3.3633 0 5.9297-0.83203 7.7031-2.5 1.7695-1.6641 2.6562-4.0859 2.6562-7.2656 0-3.1562-0.88672-5.5547-2.6562-7.2031-1.7617-1.6562-4.3281-2.4844-7.7031-2.4844zm-8.2188-6.2188h8.6719c4.8438 0 8.4453 0.34375 10.812 1.0312 2.375 0.6875 4.4102 1.8594 6.1094 3.5156 1.4883 1.4375 2.5977 3.1016 3.3281 4.9844 0.72656 1.875 1.0938 4 1.0938 6.375 0 2.4062-0.36719 4.5586-1.0938 6.4531-0.73047 1.8867-1.8398 3.5469-3.3281 4.9844-1.7109 1.6484-3.7617 2.8203-6.1562 3.5156-2.3984 0.6875-5.9844 1.0312-10.766 1.0312h-8.6719z",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d: "m568.75 367.5c0 12.504-6.6719 24.059-17.5 30.312-10.828 6.25-24.172 6.25-35 0-10.828-6.2539-17.5-17.809-17.5-30.312v-17.5h-26.25v26.25c0 2.3203-0.92188 4.5469-2.5625 6.1875s-3.8672 2.5625-6.1875 2.5625h-26.25c-6.2539 0-12.031 3.3359-15.156 8.75s-3.125 12.086 0 17.5 8.9023 8.75 15.156 8.75h26.25c2.3203 0 4.5469 0.92188 6.1875 2.5625s2.5625 3.8672 2.5625 6.1875v43.75h105c4.6406 0 9.0938-1.8438 12.375-5.125s5.125-7.7344 5.125-12.375v-105h-26.25z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m402.5 402.5c0-9.2812 3.6875-18.184 10.25-24.75 6.5664-6.5625 15.469-10.25 24.75-10.25h17.5v-17.5h-122.5v105c0 4.6406 1.8438 9.0938 5.125 12.375s7.7344 5.125 12.375 5.125h105v-35h-17.5c-9.2812 0-18.184-3.6875-24.75-10.25-6.5625-6.5664-10.25-15.469-10.25-24.75z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m577.5 210h-105v17.5h17.5c12.504 0 24.059 6.6719 30.312 17.5 6.25 10.828 6.25 24.172 0 35-6.2539 10.828-17.809 17.5-30.312 17.5h-17.5v35h35c2.3203 0 4.5469 0.92188 6.1875 2.5625s2.5625 3.8672 2.5625 6.1875v26.25c0 6.2539 3.3359 12.031 8.75 15.156s12.086 3.125 17.5 0 8.75-8.9023 8.75-15.156v-26.25c0-4.832 3.918-8.75 8.75-8.75h35v-105c0-4.6406-1.8438-9.0938-5.125-12.375s-7.7344-5.125-12.375-5.125z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m358.75 276.38-28.812-28.812-12.371 12.371 61.25 61.25h-0.003906c3.418 3.4141 8.957 3.4141 12.375 0l61.25-61.25-12.371-12.371-28.816 28.812v-48.879h-17.5v66.379l-8.75 8.75-8.75-8.75v-31.379h-17.5z",
          },
        }),
        _vm._v(" "),
        _c("path", { attrs: { d: "m358.75 227.5h17.5v17.5h-17.5z" } }),
        _vm._v(" "),
        _c("path", { attrs: { d: "m358.75 192.5h17.5v17.5h-17.5z" } }),
        _vm._v(" "),
        _c("path", { attrs: { d: "m393.75 192.5h17.5v17.5h-17.5z" } }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m472.5 70h-26.25c-4.832 0-8.75-3.918-8.75-8.75v-26.25h-105c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375v89.793c-0.83203 0.29688-1.6719 0.55859-2.4922 0.91797l-51.203 24.727h-0.003907c-5.4414-7.1875-12.199-13.281-19.914-17.953 18.66-9.3516 32.172-26.539 36.855-46.875 4.6836-20.34 0.046874-41.707-12.645-58.273-12.688-16.57-32.113-26.613-52.969-27.387-20.855-0.77734-40.969 7.793-54.855 23.375-13.887 15.578-20.098 36.543-16.938 57.172 3.1602 20.633 15.359 38.777 33.273 49.484-18.316 8.9336-31.844 25.387-37.066 45.082l-34.859 109.83c-9.8633 31.004-7.8594 64.566 5.625 94.176 14.301 31.301 13.629 67.395-1.8203 98.141l-17.57 35.133c-1.3555 2.7109-1.2109 5.9336 0.38672 8.5117 1.5938 2.582 4.4141 4.1484 7.4453 4.1484h96.25c2.3203 0 4.5469-0.92188 6.1875-2.5625s2.5625-3.8672 2.5625-6.1875c0.011719-7.9688-2.1641-15.785-6.2891-22.602-4.125-6.8125-10.043-12.363-17.109-16.047l4.1836-8.3477c12.664-25.465 16.785-54.332 11.75-82.32l-6.4922-35.699c-0.44531-2.4688 0.22656-5.0117 1.8359-6.9375 1.6055-1.9258 3.9844-3.043 6.4961-3.0469 4.0938-0.003906 7.6055 2.918 8.3477 6.9492l11.883 65.379c1.9258 10.617 2.8945 21.391 2.8945 32.184v70.488c0 2.3203 0.92188 4.5469 2.5625 6.1875s3.8672 2.5625 6.1875 2.5625h96.25c2.3203 0 4.5469-0.92188 6.1875-2.5625s2.5625-3.8672 2.5625-6.1875c0-1.7031-0.10156-3.4023-0.29688-5.0938-1.5039-13.168-9.6367-24.656-21.562-30.449-9.7578-4.9727-21.066-5.9766-31.551-2.8008l5.8281-29.121v0.003906c2.5469-12.75 3.8281-25.719 3.832-38.719v-78.32l-10.219-117.17 60.715-28.973c8.3594-3.7109 14.793-10.746 17.746-19.402 2.957-8.6562 2.1602-18.156-2.1875-26.203h82.695v-43.75c0-4.832 3.918-8.75 8.75-8.75h26.25c6.2539 0 12.031-3.3359 15.156-8.75s3.125-12.086 0-17.5-8.9023-8.75-15.156-8.75z",
          },
        }),
        _vm._v(" "),
        _c("use", { attrs: { x: "70", y: "691.25", "xlink:href": "#i" } }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "102.109375", y: "691.25", "xlink:href": "#d" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "123.683594", y: "691.25", "xlink:href": "#c" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "153.355469", y: "691.25", "xlink:href": "#a" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "182.878906", y: "691.25", "xlink:href": "#h" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "203.792969", y: "691.25", "xlink:href": "#c" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "233.464844", y: "691.25", "xlink:href": "#b" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "280.011719", y: "691.25", "xlink:href": "#g" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "311.328125", y: "691.25", "xlink:href": "#f" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "355.078125", y: "691.25", "xlink:href": "#b" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "386.398438", y: "691.25", "xlink:href": "#e" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "422.714844", y: "691.25", "xlink:href": "#a" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "452.234375", y: "691.25", "xlink:href": "#d" },
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { x: "473.8125", y: "691.25", "xlink:href": "#a" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }